import { Injectable } from '@angular/core';
import { Subject ,  Observable , BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SpinnerService {

  public isLoading = new BehaviorSubject(false);
  public loading = this.isLoading.value;
  constructor() {}
}
